const LOCAL_EN = "en-CA";
const LOCAL_FR = "fr-CA";
const RCL_LOCALE_EN = "en-US";
const RCL_LOCALE_FR = "fr";
const URL_LOCALE_EN = "en";
const URL_LOCALE_FR = "fr";
const DEFAULT_GATEWAY_EN = "YYZ";
const DEFAULT_GATEWAY_FR = "YUL";
const LOCAL_DAYJS_EN = "en";
const LOCAL_DAYJS_FR = "fr";
const FULL_IMAGE_VARIANT = "full-image";
const AD_MODULE_OFFER_TYPE_PACKAGE = "Package";
const AD_MODULE_OFFER_TYPE_RETURN_FLIGHT = "Flight";
const AD_MODULE_OFFER_TYPE_ONE_WAY_FLIGHT = "FlightOneWay";
const LOCAL_STORAGE_KEY_PREFERRED_GATEWAY = "preferredGateway";
const IMAGE_DESCRIPTION_EXTERNAL_ID_EN = "ururezc5dhrwuekgrm0u";
const IMAGE_DESCRIPTION_EXTERNAL_ID_FR = "thnwmukomy8jnnxyzoin";
const FUNCTIONS_PATH = "/.netlify/functions";
const BASECLOUDINARY_IMG_URL = "https://res.cloudinary.com/dtnwfag6s/image/list/";
const BASE_STG_ASSETS_URL =
	"https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/sunwing-prod/HotelImages/";
const BASE_FACEBOOK_SHARED_URL =
	"https://www.facebook.com/dialog/share?app_id=3664050593663266&display=popup&href=";
const BASE_TWITTER_SHARED_URL = "https://twitter.com/intent/tweet?url=";
const BASE_PINTEREST_SHARED_URL = "http://pinterest.com/pin/create/button?";
const BASE_SWG_URL = "https://www.sunwing.ca";
const DAYS_NAMES = {
	en: {
		monday: "Mon",
		tuesday: "Tue",
		wednesday: "Wed",
		thursday: "Thu",
		friday: "Fri",
		saturday: "Sat",
		sunday: "Sun",
	},
	fr: {
		monday: "lun",
		tuesday: "mar",
		wednesday: "mer",
		thursday: "jeu",
		friday: "ven",
		saturday: "sam",
		sunday: "dim",
	},
};

module.exports = {
	LOCAL_EN,
	LOCAL_FR,
	DEFAULT_GATEWAY_EN,
	DEFAULT_GATEWAY_FR,
	LOCAL_DAYJS_EN,
	LOCAL_DAYJS_FR,
	AD_MODULE_OFFER_TYPE_PACKAGE,
	AD_MODULE_OFFER_TYPE_RETURN_FLIGHT,
	AD_MODULE_OFFER_TYPE_ONE_WAY_FLIGHT,
	LOCAL_STORAGE_KEY_PREFERRED_GATEWAY,
	IMAGE_DESCRIPTION_EXTERNAL_ID_EN,
	IMAGE_DESCRIPTION_EXTERNAL_ID_FR,
	FUNCTIONS_PATH,
	RCL_LOCALE_FR,
	RCL_LOCALE_EN,
	URL_LOCALE_FR,
	URL_LOCALE_EN,
	DAYS_NAMES,
	BASECLOUDINARY_IMG_URL,
	BASE_STG_ASSETS_URL,
	FULL_IMAGE_VARIANT,
	BASE_FACEBOOK_SHARED_URL,
	BASE_TWITTER_SHARED_URL,
	BASE_PINTEREST_SHARED_URL,
	BASE_SWG_URL,
};
